// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z9PqK","type":"styles_type__Iib8P","choices":"styles_choices__4VfJL"};